/* ============================================================
   FROGQUIZ · MOTORE universale (data-driven)
   Legge: window.FQ_CONFIG (dati quiz) + window.FQ_IMAGES (slug→url)
   Monta tutto dentro #frog-quiz. Stili in frog-quiz.css.
   Modello: SCORED APERTO — ogni risposta dà punti, vince il più alto.
   ============================================================ */
(function () {
  const cfg = window.FQ_CONFIG;
  const IMG = window.FQ_IMAGES || {};
  const mount = document.getElementById('frog-quiz');
  if (!cfg || !mount) return;

  /* ---------- i18n stringhe UI motore (il contenuto quiz è già localizzato dal config) ---------- */
  const LANG = (cfg.lang === 'en') ? 'en' : 'it';
  const UI = {
    it: { start: 'Scendi in pista →', ran: 'hanno già corso', back: '← indietro', calc: 'Calcolo…', sei: 'Sei…',
      welcome: 'Bentornato! L’ultima volta eri', review: ' → Rivedi', shareAthlete: '📲 Condividi il tuo atleta',
      saveCard: '⬇️ Salva carta', restart: '↺ Rifai', challenge: '📲 Sfida i tuoi amici', close: 'Chiudi',
      shareTitle: 'Condividi la tua carta', yourCard: 'La tua carta', shareWithPhoto: '📲 Condividi (con foto)',
      copyPhoto: '📋 Copia foto', save: '⬇️ Salva', copyLink: '🔗 oppure copia il link (mostra il tuo atleta)',
      twoFaces: 'Due facce della stessa medaglia: vi capireste al volo.', youShare: 'Vi accomuna ', and: ' e ',
      yourPower: 'Il tuo potere:', you: 'SEI…', ascendant: '⬆️ Ascendente: ', likePct: '🎯 Come il ',
      ofPlayers: '% dei giocatori · 🏁 ', onTrack: ' in pista', amongFirst: '✨ <b>Sei tra i primi!</b> · 🏁 ',
      copied: '✅ Copiata!', linkCopied: '✅ Link copiato!', imgNA: 'Immagine non disponibile',
      copyNS: 'Copia non supportata qui: usa “Salva” e allega l’immagine.', copyFail: 'Copia non riuscita — usa “Salva”.',
      copyPrompt: 'Copia il link:', defTitle: 'Che atleta sei?', loc: 'it-IT',
      loginNote: 'Non hai effettuato l’accesso. <a href="/account/login">Accedi</a> per salvare il tuo risultato e ritrovarlo su ogni dispositivo.' },
    en: { start: 'Hit the track →', ran: 'have already raced', back: '← back', calc: 'Rolling…', sei: 'You are…',
      welcome: 'Welcome back! Last time you were', review: ' → See it', shareAthlete: '📲 Share your athlete',
      saveCard: '⬇️ Save card', restart: '↺ Retake', challenge: '📲 Challenge your friends', close: 'Close',
      shareTitle: 'Share your card', yourCard: 'Your card', shareWithPhoto: '📲 Share (with photo)',
      copyPhoto: '📋 Copy photo', save: '⬇️ Save', copyLink: '🔗 or copy the link (shows your athlete)',
      twoFaces: 'Two sides of the same coin: you’d get each other instantly.', youShare: 'You share ', and: ' and ',
      yourPower: 'Your power:', you: 'YOU ARE…', ascendant: '⬆️ Rising: ', likePct: '🎯 Like ',
      ofPlayers: '% of players · 🏁 ', onTrack: ' on the track', amongFirst: '✨ <b>You’re one of the first!</b> · 🏁 ',
      copied: '✅ Copied!', linkCopied: '✅ Link copied!', imgNA: 'Image not available',
      copyNS: 'Copy not supported here: use “Save” and attach the image.', copyFail: 'Copy failed — use “Save”.',
      copyPrompt: 'Copy the link:', defTitle: 'Which athlete are you?', loc: 'en-GB',
      loginNote: 'You’re not logged in. <a href="/account/login">Log in</a> to save your result and find it on any device.' }
  };
  const STR = UI[LANG];

  const imgUrl = s => IMG[s] || '';
  const C = cfg.characters;
  const bySlug = s => C.find(c => c.slug === s);
  const FAM = cfg.families;
  const AX = cfg.axlab;
  const SHARED = cfg.shared;
  const W_FAM = (cfg.weights && cfg.weights.fam) || 1;
  const W_TEMP = (cfg.weights && cfg.weights.temp) || 4;
  const PHASE1 = cfg.phase1;
  const TEMPQS = cfg.temp.slice(0, cfg.tempCount || cfg.temp.length);
  const QUESTIONS = PHASE1.concat(TEMPQS);
  const TOTAL = QUESTIONS.length;
  const QKEY = 'fq_' + cfg.handle + '_result';
  const PKEY = 'fq_' + cfg.handle + '_plays';
  const hero = (cfg.hero && cfg.hero.length ? cfg.hero : ['m-o-u-t-h', 'hare', 'party-animal'])
    .filter(bySlug);
  const heroSlugs = hero.length >= 3 ? hero.slice(0, 3) : C.slice(0, 3).map(c => c.slug);

  /* ---------- DOM ---------- */
  mount.innerHTML = `
  <section class="fq-screen fq-on" data-s="intro">
    <div class="fq-hero">${heroSlugs.map(s => `<img src="${imgUrl(s)}" alt="" style="background:${(bySlug(s) || {}).color || '#222'}">`).join('')}</div>
    <div class="fq-kick">${cfg.brand || ''}</div>
    <h1 class="fq-h1">${cfg.title || ''}</h1>
    <p class="fq-lead">${cfg.intro || ''}</p>
    <button class="fq-btn fq-block" data-act="start">${STR.start}</button>
    <div class="fq-meta">${cfg.meta || ''} · 🏁 <span data-el="count"></span> ${STR.ran}</div>
    <div class="fq-resume" data-el="resume" style="display:none">
      ${STR.welcome} <b data-el="resumeName"></b>.
      <a data-act="last">${STR.review}</a>
    </div>
    <div class="fq-loginnote" data-el="loginnote" style="display:none">🔓 ${STR.loginNote}</div>
  </section>

  <section class="fq-screen" data-s="quiz">
    <div class="fq-top"><div class="fq-bar"><i data-el="prog"></i></div><div class="fq-count" data-el="qcount"></div></div>
    <div class="fq-q" data-el="qtext"></div>
    <div class="fq-opts" data-el="opts"></div>
    <button class="fq-back" data-act="back">${STR.back}</button>
  </section>

  <section class="fq-screen" data-s="calc">
    <div class="fq-die" data-el="die">🎲</div>
    <div class="fq-calctext">${cfg.calcText || STR.calc}</div>
  </section>

  <section class="fq-screen" data-s="result">
    <div class="fq-card">
      <div class="fq-rhead" data-el="rhead"><div class="fq-fam" data-el="rfam"></div>
        <div class="fq-rimg"><img data-el="rimg" alt=""></div></div>
      <div class="fq-rbody">
        <div class="fq-ryou">${cfg.resultLead || STR.sei}</div>
        <div class="fq-rname" data-el="rname"></div>
        <div class="fq-rflav" data-el="rflav"></div>
        <div class="fq-center"><span class="fq-pill" data-el="rkey"></span></div>
        <div class="fq-rstat" data-el="rstat"></div>
        <div class="fq-ident" data-el="rident"></div>
        <div class="fq-power" data-el="rpower"></div>
        <div class="fq-also">
          <img data-el="aimg" alt="">
          <div class="fq-also-t"><b>${STR.ascendant}<span data-el="aname"></span></b><br>
            <span data-el="ascdesc" class="fq-i"></span><br><span data-el="ascwhy" class="fq-dim"></span></div>
        </div>
      </div>
    </div>
    <div class="fq-actions">
      <button class="fq-btn fq-block" data-act="share">${STR.shareAthlete}</button>
      <div class="fq-row2">
        <button class="fq-btn fq-alt" data-act="save">${STR.saveCard}</button>
        <button class="fq-btn fq-alt" data-act="restart">${STR.restart}</button>
      </div>
    </div>
    <div class="fq-cta">
      <p>${cfg.ctaText || ''}</p>
      <button class="fq-btn" data-act="share">${STR.challenge}</button>
    </div>
  </section>
  <div class="fq-sharebox" data-el="sharebox">
    <div class="fq-sharecard">
      <button class="fq-x" data-act="closeshare" aria-label="${STR.close}">✕</button>
      <div class="fq-sharetitle">${STR.shareTitle}</div>
      <img class="fq-sharepreview" data-el="sharepreview" alt="${STR.yourCard}">
      <button class="fq-btn fq-block" data-act="nativeshare" data-el="nativebtn" style="display:none">${STR.shareWithPhoto}</button>
      <div class="fq-row2" style="margin-top:10px">
        <button class="fq-btn fq-alt" data-act="copyimg" data-el="copyimgbtn">${STR.copyPhoto}</button>
        <button class="fq-btn fq-alt" data-act="save">${STR.save}</button>
      </div>
      <button class="fq-sharelink" data-act="copylink" data-el="copybtn">${STR.copyLink}</button>
    </div>
  </div>
  <canvas data-el="cv" width="1080" height="1350" style="position:fixed;left:-99999px;top:0;width:1080px;height:auto;pointer-events:none"></canvas>`;

  const $ = s => mount.querySelector('[data-el="' + s + '"]');
  const screen = id => { mount.querySelectorAll('.fq-screen').forEach(x => x.classList.toggle('fq-on', x.dataset.s === id)); window.scrollTo(0, 0); };
  const setAcc = c => mount.style.setProperty('--fq-acc', c || '#ffd23f');

  /* ---------- STATO + SCORING ---------- */
  let answers = [], me = null;

  function famScores() { const sc = {}; answers.forEach((a, i) => { const op = QUESTIONS[i] && QUESTIONS[i].o[a]; if (op && op.f) sc[op.f] = (sc[op.f] || 0) + 2; }); return sc; }
  function tempVec() { const T = [0, 0, 0, 0, 0]; answers.forEach((a, i) => { const op = QUESTIONS[i] && QUESTIONS[i].o[a]; if (op && op.d) op.d.forEach((v, ax) => T[ax] += v); }); return T; }
  function cosine(a, b) { let d = 0, na = 0, nb = 0; for (let i = 0; i < 5; i++) { d += a[i] * b[i]; na += a[i] * a[i]; nb += b[i] * b[i]; } return (na && nb) ? d / Math.sqrt(na * nb) : 0; }
  function scoreAll() { const fs = famScores(), T = tempVec(); return C.map(c => [c, W_FAM * (fs[c.fam] || 0) + W_TEMP * cosine(T, c.temp)]).sort((a, b) => b[1] - a[1]); }
  function sharedTrait(a, b) {
    const hits = []; for (let ax = 0; ax < 5; ax++) { if (a.temp[ax] && b.temp[ax] && Math.sign(a.temp[ax]) === Math.sign(b.temp[ax])) hits.push([ax, Math.abs(a.temp[ax]) + Math.abs(b.temp[ax])]); }
    hits.sort((x, y) => y[1] - x[1]);
    if (!hits.length) return STR.twoFaces;
    return STR.youShare + hits.slice(0, 2).map(h => SHARED[h[0]][a.temp[h[0]] > 0 ? 0 : 1]).join(STR.and) + '.';
  }
  function traitLabel(T) {
    const o = [0, 1, 2, 3, 4].filter(ax => T[ax] !== 0).sort((a, b) => Math.abs(T[b]) - Math.abs(T[a]));
    return o.slice(0, 2).map(ax => AX[ax][T[ax] > 0 ? 0 : 1]).join(' · ') || (FAM[me.best.fam] || {}).l || '';
  }

  /* ---------- RENDER ---------- */
  function render() {
    const i = answers.length, item = QUESTIONS[i];
    $('prog').style.width = (i / TOTAL * 100) + '%';
    $('qcount').textContent = (i + 1) + '/' + TOTAL;
    $('qtext').textContent = item.q;
    mount.querySelector('[data-act="back"]').style.visibility = i ? 'visible' : 'hidden';
    const o = $('opts'); o.innerHTML = '';
    item.o.forEach((op, idx) => {
      const b = document.createElement('button'); b.className = 'fq-opt';
      b.innerHTML = '<span class="fq-em">' + op.e + '</span><span>' + op.t + '</span>';
      b.onclick = () => pick(idx); o.appendChild(b);
    });
  }
  function pick(idx) { answers.push(idx); if (answers.length < TOTAL) render(); else finish(); }
  function back() { if (!answers.length) return; answers.pop(); render(); }

  function finish() {
    $('prog').style.width = '100%'; screen('calc');
    let n = 0; const die = $('die'), faces = ['🎲', '⚀', '⚁', '⚂', '⚃', '⚄', '⚅'];
    const iv = setInterval(() => { die.textContent = faces[1 + (n++ % 6)]; }, 120);
    setTimeout(() => { clearInterval(iv); compute(); renderResult(); screen('result'); }, 1500);
  }
  function compute() {
    const r = scoreAll();
    me = { best: r[0][0], second: (r[1] ? r[1][0] : r[0][0]), T: tempVec() };
  }
  function renderResult() {
    const c = me.best, fam = FAM[c.fam] || { e: '', l: '' };
    setAcc(c.color);
    $('rhead').style.background = 'linear-gradient(180deg,' + c.color + ' 0%,transparent 120%)';
    $('rfam').innerHTML = '<span>' + fam.e + '</span> ' + fam.l;
    $('rimg').src = imgUrl(c.slug);
    $('rname').textContent = c.name;
    $('rflav').textContent = '“' + c.flavor + '”';
    $('rkey').textContent = traitLabel(me.T);
    $('rident').textContent = c.id;
    $('rpower').innerHTML = '<b>' + STR.yourPower + '</b> ' + c.power;
    const s = me.second;
    $('aimg').src = imgUrl(s.slug); $('aname').textContent = s.name;
    $('ascdesc').textContent = s.power;
    $('ascwhy').textContent = sharedTrait(c, s);
    saveAndStats();
  }

  /* ---------- PERSISTENZA + CONTATORE (worker se c'è, altrimenti localStorage) ---------- */
  const fmt = n => (n || 0).toLocaleString(STR.loc);
  function lsPlays() { return parseInt(localStorage.getItem(PKEY) || '') || cfg.baseCount || 0; }
  function saveResult() { try { localStorage.setItem(QKEY, JSON.stringify({ b: me.best.slug, bn: me.best.name, bimg: imgUrl(me.best.slug), s: me.second.slug, T: me.T })); } catch (e) { } }

  const CKEY = 'fq_' + cfg.handle + '_counted';
  function showStat(d, slug) {
    const total = (cfg.baseCount || 0) + (d.total || 0);
    // % reale solo con dati sufficienti (>=10 giocatori). Sotto soglia: niente % inventata, solo "tra i primi".
    if (d.total >= 10 && d.dist && d.dist[slug]) {
      const pct = Math.max(1, Math.round(d.dist[slug] / d.total * 100));
      $('rstat').innerHTML = STR.likePct + '<b>' + pct + '</b>' + STR.ofPlayers + fmt(total) + STR.onTrack;
    } else {
      $('rstat').innerHTML = STR.amongFirst + fmt(total) + STR.onTrack;
    }
  }
  function saveAndStats() {
    saveResult();
    const slug = me.best.slug;
    const cust = window.FQ_CUSTOMER;
    if (!cfg.workerUrl) { statFallback(slug, true); return; }
    const base = cfg.workerUrl.replace(/\/$/, '') + '/' + cfg.handle;
    let req;
    if (cust) {
      // LOGGATO: il worker conta una volta per persona e salva il risultato sull'account
      const data = { b: slug, bn: me.best.name, bimg: imgUrl(slug), s: me.second.slug, T: me.T };
      req = fetch(base + '/done', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ result: slug, customer: cust, data: data }) });
    } else {
      // ANONIMO: conta una volta per browser
      const first = !localStorage.getItem(CKEY);
      if (first) { try { localStorage.setItem(CKEY, '1'); } catch (e) { } }
      req = first
        ? fetch(base + '/done', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ result: slug }) })
        : fetch(base + '/stats');
    }
    req.then(r => r.json()).then(d => showStat(d, slug)).catch(() => statFallback(slug, false));
  }
  function statFallback(slug, first) {
    let p = lsPlays(); if (first) { p++; try { localStorage.setItem(PKEY, String(p)); } catch (e) { } }
    // worker irraggiungibile: nessuna distribuzione disponibile → niente % inventata
    $('rstat').innerHTML = STR.amongFirst + fmt(p) + STR.onTrack;
  }
  // risultato salvato: prima dall'account (cross-device), poi dal browser
  function savedResult() {
    if (window.FQ_SAVED && window.FQ_SAVED[cfg.handle]) return window.FQ_SAVED[cfg.handle];
    try { return JSON.parse(localStorage.getItem(QKEY)); } catch (e) { return null; }
  }
  function showLast() {
    const d = savedResult(); if (!d || !d.b) return;
    me = { best: bySlug(d.b), second: bySlug(d.s) || bySlug(d.b), T: d.T || [0, 0, 0, 0, 0] };
    renderResult(); screen('result');
  }
  function initHub() {
    if (cfg.workerUrl) {
      fetch(cfg.workerUrl.replace(/\/$/, '') + '/' + cfg.handle + '/stats').then(r => r.json())
        .then(d => { $('count').textContent = fmt((cfg.baseCount || 0) + ((d && d.total) || 0)); }).catch(() => { $('count').textContent = fmt(lsPlays()); });
    } else $('count').textContent = fmt(lsPlays());
    // reminder soft: solo se NON loggato (il risultato non verrà salvato sull'account)
    if (!window.FQ_CUSTOMER) { const ln = $('loginnote'); if (ln) ln.style.display = 'block'; }
    const d = savedResult();
    if (d && d.b) {
      const c = bySlug(d.b);
      if (c) { $('resumeName').textContent = c.name; $('resume').style.display = 'block'; }
      try { if (!localStorage.getItem(QKEY)) localStorage.setItem(QKEY, JSON.stringify(d)); } catch (e) { } // allinea il browser all'account
    }
  }

  /* ---------- SHARE (riusa immagine già caricata: niente CORS su mobile) ---------- */
  function roundRect(x, a, b, w, h, r) { x.beginPath(); x.moveTo(a + r, b); x.arcTo(a + w, b, a + w, b + h, r); x.arcTo(a + w, b + h, a, b + h, r); x.arcTo(a, b + h, a, b, r); x.arcTo(a, b, a + w, b, r); x.closePath(); }
  function lines(ctx, t, max) { const ws = String(t).split(' '); const out = []; let ln = ''; for (const w of ws) { const test = ln + w + ' '; if (ctx.measureText(test).width > max && ln) { out.push(ln.trim()); ln = w + ' '; } else ln = test; } out.push(ln.trim()); return out; }
  function drawLines(ctx, arr, cx, y, lh, align) { ctx.textAlign = align || 'center'; for (const l of arr) { ctx.fillText(l, cx, y); y += lh; } return y; }

  // CARD COMPLETA: immagine + nome + frase + tratti + identità + potere + ascendente + footer
  function buildCard(cb) {
    const c = me.best, s = me.second, cv = $('cv'), x = cv.getContext('2d');
    const W = 1080, M = 40, IN = 56, TW = W - 2 * (M + IN);
    const fam = FAM[c.fam] || { e: '', l: '' };
    const F = (sz, w, it) => (it ? 'italic ' : '') + (w ? w + ' ' : '') + sz + 'px "Trebuchet MS",Arial,sans-serif';

    // misura (le righe non cambiano dopo il resize)
    x.font = F(34, null, true); const flav = lines(x, '“' + c.flavor + '”', TW);
    x.font = F(30); const idl = lines(x, c.id, TW);
    x.font = F(31, 'bold'); const powAll = lines(x, STR.yourPower + ' ' + c.power, TW - 40);
    x.font = F(25, null, true); const ascP = lines(x, s.power, TW - 130);
    x.font = F(24); const why = lines(x, sharedTrait(c, s), TW - 130);

    // layout
    const band = 470;
    let y = M + band + 66;
    const yYou = y; y += 90;
    const yName = y; y += 96;
    const yFlav = y; y += flav.length * 42 + 22;
    const yPill = y; y += 70;
    const yId = y; y += idl.length * 44 + 28;
    const powH = powAll.length * 46 + 56; const yPow = y; y += powH + 34;
    const yDiv = y; y += 30;
    const ascH = Math.max(120, ascP.length * 34 + why.length * 32 + 44); const yAsc = y; y += ascH + 24;
    const yFoot = y + 6; y += 60;
    const H = y + 40;

    cv.width = W; cv.height = H;
    const ctx = cv.getContext('2d');

    ctx.fillStyle = c.color; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = 'rgba(12,14,22,.96)'; roundRect(ctx, M, M, W - 2 * M, H - 2 * M, 44); ctx.fill();
    ctx.save(); roundRect(ctx, M, M, W - 2 * M, H - 2 * M, 44); ctx.clip(); ctx.fillStyle = c.color; ctx.fillRect(M, M, W - 2 * M, band); ctx.restore();
    const sz = 330, ix = (W - sz) / 2, iy = M + 118, rimg = $('rimg');
    if (rimg && rimg.complete && rimg.naturalWidth) { ctx.save(); roundRect(ctx, ix, iy, sz, sz, 28); ctx.clip(); try { ctx.drawImage(rimg, ix, iy, sz, sz); } catch (e) { } ctx.restore(); ctx.lineWidth = 8; ctx.strokeStyle = 'rgba(0,0,0,.22)'; roundRect(ctx, ix, iy, sz, sz, 28); ctx.stroke(); }
    // badge famiglia: emoji + testo a posizioni FISSE (measureText sbaglia la larghezza emoji su iOS → testo che sborda)
    ctx.font = F(28, '800'); const blabel = fam.l.toUpperCase(); const blw = ctx.measureText(blabel).width;
    const bemW = 40, bgap = 14, bpad = 28; const bw = bpad * 2 + bemW + bgap + blw; const bx = (W - bw) / 2;
    ctx.fillStyle = 'rgba(10,12,20,.82)'; roundRect(ctx, bx, M + 28, bw, 56, 28); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.textAlign = 'left';
    ctx.fillText(fam.e, bx + bpad, M + 64); ctx.fillText(blabel, bx + bpad + bemW + bgap, M + 64);
    ctx.textAlign = 'center';

    ctx.fillStyle = '#9aa3bd'; ctx.font = F(26, '700'); ctx.fillText(STR.you, W / 2, yYou);
    ctx.fillStyle = '#fff'; ctx.font = F(76, '800'); ctx.fillText(c.name.toUpperCase(), W / 2, yName);
    ctx.fillStyle = c.color; ctx.font = F(34, null, true); drawLines(ctx, flav, W / 2, yFlav, 42);
    ctx.font = F(26, '700'); const tl = traitLabel(me.T); const tw = ctx.measureText(tl).width + 36; ctx.fillStyle = 'rgba(255,255,255,.08)'; roundRect(ctx, (W - tw) / 2, yPill - 34, tw, 48, 14); ctx.fill(); ctx.fillStyle = '#cfd6ea'; ctx.fillText(tl, W / 2, yPill);
    ctx.fillStyle = '#e6e8f2'; ctx.font = F(30); drawLines(ctx, idl, W / 2, yId, 44);
    ctx.fillStyle = 'rgba(255,255,255,.06)'; roundRect(ctx, M + IN, yPow, TW, powH, 18); ctx.fill();
    ctx.fillStyle = '#e6e8f2'; ctx.font = F(31, 'bold'); drawLines(ctx, powAll, W / 2, yPow + 50, 46);
    ctx.strokeStyle = 'rgba(255,255,255,.12)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(M + IN, yDiv); ctx.lineTo(W - M - IN, yDiv); ctx.stroke();
    const aimg = $('aimg'), at = M + IN, asz = 96;
    if (aimg && aimg.complete && aimg.naturalWidth) { ctx.save(); roundRect(ctx, at, yAsc, asz, asz, 16); ctx.clip(); try { ctx.drawImage(aimg, at, yAsc, asz, asz); } catch (e) { } ctx.restore(); }
    const axx = at + asz + 22;
    ctx.textAlign = 'left'; ctx.fillStyle = '#fff'; ctx.font = F(28, '800'); ctx.fillText(STR.ascendant + s.name, axx, yAsc + 30);
    ctx.fillStyle = '#9aa3bd'; ctx.font = F(25, null, true); const ay = drawLines(ctx, ascP, axx, yAsc + 64, 34, 'left');
    ctx.fillStyle = 'rgba(154,163,189,.78)'; ctx.font = F(24); drawLines(ctx, why, axx, ay + 4, 32, 'left');
    ctx.textAlign = 'center'; ctx.fillStyle = '#9aa3bd'; ctx.font = F(30, '700'); ctx.fillText('🐸 frogames.it  ·  ' + (cfg.title || STR.defTitle), W / 2, yFoot);

    try { cv.toBlob(cb, 'image/png'); } catch (e) { cb(null); }
  }
  function shareInfo() {
    const c = me.best;
    const text = (cfg.shareText || 'Sono {name}!').replace('{name}', c.name);
    const quiz = location.origin + location.pathname;
    let url = quiz;
    if (cfg.workerUrl) {
      // link che, condiviso, mostra l'anteprima del TUO atleta e poi reindirizza al quiz
      let img = imgUrl(c.slug); if (img.indexOf('//') === 0) img = 'https:' + img;
      const p = new URLSearchParams({ n: c.name, g: cfg.game || '', i: img, u: quiz, l: LANG });
      url = cfg.workerUrl.replace(/\/$/, '') + '/share/' + cfg.handle + '/' + c.slug + '?' + p.toString();
    }
    return { text, url, full: text + ' ' + url };
  }
  let _sblob = null, _surl = null;
  function openShare() {
    buildCard(blob => {
      _sblob = blob;
      if (_surl) URL.revokeObjectURL(_surl);
      _surl = blob ? URL.createObjectURL(blob) : '';
      $('sharepreview').src = _surl;
      let canFile = false;
      try { canFile = blob && navigator.canShare && navigator.canShare({ files: [new File([blob], 'x.png', { type: 'image/png' })] }); } catch (e) { }
      const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      $('nativebtn').style.display = (coarse && navigator.share && canFile) ? 'block' : 'none';
      $('sharebox').classList.add('show');
    });
  }
  function closeShare() { $('sharebox').classList.remove('show'); }
  function dl(blob) { const u = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = u; a.download = cfg.handle + '-' + me.best.slug + '.png'; a.click(); URL.revokeObjectURL(u); }
  function saveImg() { if (_sblob) return dl(_sblob); buildCard(b => { if (!b) { alert(STR.imgNA); return; } dl(b); }); }
  function copyImage() {
    if (!_sblob || !navigator.clipboard || !window.ClipboardItem) { alert(STR.copyNS); return; }
    navigator.clipboard.write([new ClipboardItem({ 'image/png': _sblob })])
      .then(() => { $('copyimgbtn').textContent = STR.copied; setTimeout(() => { $('copyimgbtn').textContent = STR.copyPhoto; }, 1800); })
      .catch(() => alert(STR.copyFail));
  }
  function nativeShare() {
    const { text, url, full } = shareInfo();
    if (_sblob && navigator.canShare) {
      try { const f = new File([_sblob], cfg.handle + '.png', { type: 'image/png' }); if (navigator.canShare({ files: [f] })) { navigator.share({ files: [f], text: full }).catch(() => { }); return; } } catch (e) { }
    }
    if (navigator.share) navigator.share({ title: cfg.title, text, url }).catch(() => { });
  }
  function copyLink() {
    const { full } = shareInfo();
    const done = () => { $('copybtn').textContent = STR.linkCopied; setTimeout(() => { $('copybtn').textContent = STR.copyLink; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(full).then(done).catch(() => prompt(STR.copyPrompt, full));
    else prompt(STR.copyPrompt, full);
  }

  function start() { setAcc('#ffd23f'); answers = []; me = null; render(); screen('quiz'); }
  function restart() { setAcc('#ffd23f'); screen('intro'); }

  /* ---------- EVENTI ---------- */
  mount.addEventListener('click', e => {
    const b = e.target.closest('[data-act]'); if (!b) return;
    const a = b.dataset.act;
    if (a === 'start') start(); else if (a === 'back') back(); else if (a === 'share') openShare();
    else if (a === 'closeshare') closeShare(); else if (a === 'copylink') copyLink(); else if (a === 'nativeshare') nativeShare(); else if (a === 'copyimg') copyImage();
    else if (a === 'save') saveImg(); else if (a === 'restart') restart(); else if (a === 'last') showLast();
  });

  // pre-carica le immagini dei 3 eroi già fatto in markup; init contatore + bentornato
  initHub();
})();
